import type { CurrentUser } from "@nabble/sdk";
import { roleNames } from "../model/organizationRoles";

const SUITE_ADMINISTRATOR = "Suite administrator";

/** True when the user works with several organizations at once. */
export function seesCombinedView(user: CurrentUser): boolean {
  return user.organizationView === "COMBINED" && user.organizations.length > 1;
}

/** The line under the user's name in the header: their roles where they are working. */
export function userRoleLabel(user: CurrentUser): string {
  if (seesCombinedView(user)) {
    return user.suiteAdmin ? SUITE_ADMINISTRATOR : `${user.organizations.length} organizations`;
  }
  if (user.organization) return `${roleNames(user.organization.roles)} · ${user.organization.name}`;
  return user.suiteAdmin ? SUITE_ADMINISTRATOR : "";
}
